import { createSelector } from 'reselect';
import {
  currentClientDataSelector,
  goals as goalsSelector,
} from '../../../../../../FinancialPlan/FinancialPlanSelector';

export const selectEstatePlanningDocumentTypes = createSelector(
  currentClientDataSelector,
  ({ EstatePlanningDocumentsOption }) => EstatePlanningDocumentsOption,
);

export const selectEstatePlanningGoal = createSelector(goalsSelector, goals =>
  goals.find(({ GoalType }) => GoalType === 'estatePlanning'),
);
